export const RAW_HTML_DEMARCATOR = "±±±";

const rawHtmlWrapperRegex = new RegExp(
  `<script data-token="true"[^>]*>${RAW_HTML_DEMARCATOR}([\\S\\s]*?)${RAW_HTML_DEMARCATOR}<\\/script>`,
  "g"
);

// Used in tandem with the RawHtml component, which wraps the raw HTML in
// a <script> tag to prevent React from escaping it.
// This function removes those wrappers to get the original raw HTML back.
export const stripRawHtmlWrappers = html =>
  html.replace(rawHtmlWrapperRegex, "$1");
